import { render } from "./MultipleChoice.vue?vue&type=template&id=383a9527"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"

import "./MultipleChoice.vue?vue&type=style&index=0&id=383a9527&lang=scss"

import exportComponent from "/app/tmp/alangray/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__